import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSelectingSomethingOtherThanGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';
import { siteUserForcePasswordUpdate } from '../actions/SiteUserMenuActions';
import { ISiteUserInfo } from '../models/ISiteUserInfo';

export const SiteUserForcePasswordUpdateAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserForcePasswordReset,
  translateName: Messages.forcePasswordUpdate_action,
  isVisible: (_targetItems: ISiteUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthPasswordExpirationEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], _state: AppState) => {
    return isSelectingSomethingOtherThanGuest(targetItems);
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserForcePasswordUpdate(targetItems)
};
